import {Plugin} from 'prosemirror-state';
import {Decoration, DecorationSet} from 'prosemirror-view';
import {findAccordion, findGrid} from '../helper/nodeSelection';

export const borderNode = new Plugin({
      props: {
        decorations: state => {
          const decorations = [];

          const grid = findGrid(state);
          if (grid) {
            decorations.push(
                Decoration.node(grid.pos, grid.pos + grid.node.nodeSize, {
                  class: 'selected',
                }));
          }

          const accordion = findAccordion(state);
          if (accordion) {
            decorations.push(Decoration.node(accordion.pos,
                accordion.pos + accordion.node.nodeSize, {
                  class: 'selected',
                }));
          }

          return DecorationSet.create(state.doc, decorations);
        },
      },
    }
);